import { Component, inject } from "@angular/core";
import { ItemLinkableBase } from "@app/shared/linkable/item-linkable-base";
import { Pages } from "@constants/pages/Pages";
import { TabService } from "@services/tabs/TabService";
import { Observable, firstValueFrom } from "rxjs";
import { IHasGuid } from "@app/shared/interfaces/IHasGuid";
import { DatamanagementDataService } from "@app/datamanagement/services/datamanagement-data.service";
import { TranslocoService, provideTranslocoScope } from "@jsverse/transloco";

@Component({
    selector: "datamanagement-linkable",
    templateUrl: "./datamanagement-linkable.component.html",
    styleUrls: ["./datamanagement-linkable.component.scss"],
    standalone: false,
    providers: [provideTranslocoScope("datamanagement")],
})
export class DatamanagementLinkableComponent extends ItemLinkableBase {
    hasAccessChecks = {};
    accessCheckInProgress = false;

    private _dmDataService = inject(DatamanagementDataService);
    private _pages = inject(Pages);
    private _tabService = inject(TabService);
    private _translocoService = inject(TranslocoService);
    
    hasAccessToItem(guid: string): Observable<boolean> {
        return this._dmDataService.hasAccess(guid);
    }

    async openTab(item: IHasGuid, hasAccess: boolean) {
        if (hasAccess === true) {
            this._tabService.generateTab(
                this._pages.DataManagement,
                item.guid,
                `(P) ${item[this.displayValueProp]}`
            );
        } else {
            // Nothing in this template uses the transloco pipe/directive, so the lazy scope
            // is not loaded yet and a synchronous translate() would return the raw key.
            await firstValueFrom(
                this._translocoService.load(
                    `datamanagement/${this._translocoService.getActiveLang()}`
                )
            );
            this._toastr.warning(
                this._translocoService.translate(
                    "datamanagement.datamanagementLinkable.notEnoughRights"
                )
            );
        }
    }
}
